import { createFileRoute } from '@tanstack/react-router';

import { grantListDeps, loadGrantList } from '../features/grants/list-loader';
import { GrantTypePage, grantTypeHead } from '../features/grants/type-page';
import { grantTypeSearch } from '../features/grants/type-search';

/**
 * `/news/loans` — 융자·보증 전용 목록.
 *
 * 화면은 `GrantTypePage` 하나를 넷이 나눠 쓴다. 네 벌로 만들면 한쪽만
 * 고쳐지고, 그때부터 유형마다 다르게 동작하는 목록이 된다.
 */
export const Route = createFileRoute('/news/loans')({
  validateSearch: grantTypeSearch,
  loaderDeps: ({ search }) => grantListDeps(search),
  loader: ({ context, deps }) => loadGrantList(context, deps, { support: 'loan' }),
  head: () => grantTypeHead('loan', '/news/loans'),
  component: () => (
    <GrantTypePage type="loan" path="/news/loans" filters={Route.useLoaderDeps()} loaded={Route.useLoaderData()} />
  ),
});
